import React from "react";
import { useNavigate } from "react-router-dom";
import "./SubmissionUpdateCard .css";


const SubmissionUpdateCard = ({ submissions }) => {
  const navigate = useNavigate();

  return (
    <div className="submissions-table-container">
      <p>
            Here you'd find all your previous submissions. If encountered with
            any problem please make sure to report it right away to us and it
            would be reviewed as soon as possible.
          </p>
          <hr />
          <div className="submission-table-conatiner-scrollable">
<table className="submissions-table">
        <thead>
          <tr>
            <th>Reference</th>
            <th>Status</th>
            <th>Coordinator</th>
            <th>Last Updated</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {submissions?.length > 0 ? (
            submissions?.map((sub, idx) => (
              <tr key={idx} style={{backgroundColor :sub?.discussion?.length > 0 &&
      sub.discussion[sub.discussion.length - 1]?.poster?.role.trim().toLowerCase() != "student" &&
      sub?.result?.trim().toLowerCase() === "in process"
        ? "#efe93375"
        : null,}}>
                <td>{sub.problemRef}</td>
                <td>
                  <span className={`status ${sub.result.toLowerCase()}`}>
                    {sub.result}
                  </span>
                </td>
                <td>{sub.coordinator?.name || "—"}</td>
                <td>{new Date(sub.updatedAt).toLocaleString()}</td>
                <td>
                  <button
                    className="more-btn"
                    onClick={() =>
                      navigate(`/Submission/${sub.problemRef}`)
                    }
                  >
                    More →
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="5" className="no-data">
                No submissions found.
              </td>
            </tr>
          )}
        </tbody>
      </table>
          </div>
      
    </div>
  );
};

export default SubmissionUpdateCard;
